import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';


import { Observable } from 'rxjs/Observable';
import'rxjs/add/operator/catch';
import'rxjs/add/operator/map';
import'rxjs/add/operator/filter';

import { ConfigService } from '../config/config.service';
import { CartService } from '../cart/cart.service';

import { ProductCategory } from './product-category';
import { Store } from '@ngrx/store/index';
import { ProductCategoriesState } from './product-categories.store';
import { ProductCategoriesActions } from './product-categories.actions';
import { ContextService } from '../context/context.service';
import { LoggingService } from '../loging/logging.service';
export class ProductCategoriesBrowserComponent {
private config: any;
    productCategoriesObservable: Observable<ProductCategory[]>;
    productCategories: ProductCategory[];
    oddProductCategories: ProductCategory[];
    evenProductCategories: ProductCategory[];
private productCategoryIndicies: number[] = [];
/**
 * @param {?} router
 * @param {?} configService
 * @param {?} store
 * @param {?} contextService
 * @param {?} loggingService
 */
constructor(
private router: Router,
private configService: ConfigService,
private store: Store<ProductCategoriesState>,
private contextService: ContextService,
private loggingService: LoggingService
    ) {
        this.productCategoriesObservable = store.select('productCategories');

        let count = 0;

        this.productCategoriesObservable.subscribe(
            (productCategoriesArray: ProductCategory[]) => {

                this.productCategories = productCategoriesArray;

                this.loggingService.log('product-categories-browser: productCategories = ');
                this.loggingService.log(this.productCategories);

                this.oddProductCategories = productCategoriesArray.filter(
                    (productCategory: ProductCategory, index) => {
                        if (!(productCategory.DisplayIndex % 2)) {
                            this.productCategoryIndicies.push(count);
                            count++;
                            return true;
                        }
                    });

                this.evenProductCategories = productCategoriesArray.filter(
                    (productCategory: ProductCategory, index) => {
                        if ((productCategory.DisplayIndex % 2)) {
                            return true;
                        }
                    });

            })

        this.configService.getConfig((configuration: any) => {
            this.config = configuration;
        });
    }
/**
 * @param {?} productCategory
 * @return {?}
 */
gotoDetail(productCategory: ProductCategory): void {
        this.router.navigate(['home/' + productCategory.Key]);
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'my-product-categories-browser',
    template: "<div class=\"product-category-browser\"> <div *ngFor=\"let productCategoryIndex of productCategoryIndicies\" class=\"row\"> <div class=\"col-xs-6 product-category-image-div\"> <img (click)=\"gotoDetail(oddProductCategories[productCategoryIndex])\" src=\"{{oddProductCategories[productCategoryIndex].ImageUrl}}\" class=\"img-responsive center-block product-category-image\" alt=\"{{oddProductCategories[productCategoryIndex].Key}}\" align=\"middle\" /><br/> <span class=\"product-category-name\" (click)=\"gotoDetail(oddProductCategories[productCategoryIndex])\">{{oddProductCategories[productCategoryIndex].Key}}</span> </div> <div *ngIf=\"evenProductCategories[productCategoryIndex]\" class=\"col-xs-6 product-category-image-div\"> <img id=\"mainImage\" (click)=\"gotoDetail(evenProductCategories[productCategoryIndex])\" src=\"{{evenProductCategories[productCategoryIndex].ImageUrl}}\" class=\"img-responsive center-block product-category-image\" alt=\"{{evenProductCategories[productCategoryIndex].Key}}\" align=\"middle\" /><br/> <span class=\"product-category-name\" (click)=\"gotoDetail(evenProductCategories[productCategoryIndex])\">{{evenProductCategories[productCategoryIndex].Key}}</span> </div> </div> </div>",
    styles: ["// component styles are encapsulated and only applied to their components .home-text { color: #ff0000; } .product-category-name{ font-size: 1em; font-weight: bolder; width: 100%; } .product-category-image-div{ align-content: center; margin-bottom: 1em; } .product-category-image-list{ overflow: auto; }"]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Router, },
{type: ConfigService, },
{type: Store, },
{type: ContextService, },
{type: LoggingService, },
];
}

function ProductCategoriesBrowserComponent_tsickle_Closure_declarations() {
/** @type {?} */
ProductCategoriesBrowserComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ProductCategoriesBrowserComponent.ctorParameters;
/** @type {?} */
ProductCategoriesBrowserComponent.prototype.config;
/** @type {?} */
ProductCategoriesBrowserComponent.prototype.productCategoriesObservable;
/** @type {?} */
ProductCategoriesBrowserComponent.prototype.productCategories;
/** @type {?} */
ProductCategoriesBrowserComponent.prototype.oddProductCategories;
/** @type {?} */
ProductCategoriesBrowserComponent.prototype.evenProductCategories;
/** @type {?} */
ProductCategoriesBrowserComponent.prototype.productCategoryIndicies;
/** @type {?} */
ProductCategoriesBrowserComponent.prototype.router;
/** @type {?} */
ProductCategoriesBrowserComponent.prototype.configService;
/** @type {?} */
ProductCategoriesBrowserComponent.prototype.store;
/** @type {?} */
ProductCategoriesBrowserComponent.prototype.contextService;
/** @type {?} */
ProductCategoriesBrowserComponent.prototype.loggingService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
